import React from "react";
import { Tag, Tooltip } from "antd";
import { NEW_STAFF_DAYS, newStaffOf } from "../utils/newStaff";

/** تگِ «جدید» کنارِ نامِ پرسنل — فقط در ۴۵ روزِ اولِ استخدام. */
export default function NewStaffTag({ rec, style }) {
  if (!newStaffOf(rec)) return null;
  return (
    <Tooltip title={`پرسنل جدید — تا ${NEW_STAFF_DAYS} روز بعد از استخدام خودکار برداشته می‌شود`}>
      <Tag color="green" style={{ marginInlineStart: 4, fontSize: 11, lineHeight: "18px", ...style }}>جدید</Tag>
    </Tooltip>
  );
}
